/*
 * FOOTER
 */
import React from 'react';
import Menu from '@/components/shared/Menu';
import '@/styles/components/footer.scss';

// Year
const footerDate: Date = new Date();
const footerYear: number = footerDate.getFullYear();

const Footer: React.FC = () => {
    
    return (
        <footer id="lm-footer">
            <section id="lm-footer-top">
                <div className="container">
                    <Menu name="footer-nav" />
                </div>
            </section>
            <section id="lm-footer-bottom">
                <div className="container">
                    <Menu name="legal-nav" />
                    <p className="footer-year">© { footerYear } Live Mobile Now. All Rights Reserved.</p>
                </div>        
            </section>
            { /* TODO: Cookie Consent */ }
        </footer>
    );
};
export default Footer;